<template>
  <router-link to="/">
    <img
      class="img-fluid for-light"
      src="/minilogo.png"
      alt=""
    /><img
      class="img-fluid for-dark"
      src="/minilogo.png"
      alt=""
    />
  </router-link>
</template>
<script>

  export default {
    name: 'Logo',
  };
</script>
